// Tiny connection-status store. apiFetch flips this on network-level fetch failures
// (backend unreachable — a thrown TypeError, NOT an HTTP 4xx/5xx) and back on the next
// successful response. ConnectionBanner subscribes and shows a persistent banner while
// offline. Module-level so the shared fetch path (api.ts) can update it without prop-drilling.

type Listener = (online: boolean) => void;

let online = true;
const listeners = new Set<Listener>();

export function setConnectionOnline(value: boolean): void {
  if (value === online) return;
  online = value;
  for (const l of listeners) l(online);
}

export function getConnectionOnline(): boolean {
  return online;
}

export function subscribeConnection(l: Listener): () => void {
  listeners.add(l);
  return () => { listeners.delete(l); };
}
